import React, { createContext, useContext, useState } from 'react';
import { GlobalAlertOptions } from '@/components/AppAlert/alert.types';

const defaultAlertOptions: GlobalAlertOptions = {
  mui: {
    severity: 'success',
    closeText: 'Close Alert Banner',
  },
  app: {
    title: undefined,
    withMain: false,
  },
  custom: {
    description: '',
    withTransition: true,
    closable: true,
  },
};

export interface AlertContextType {
  isAlertActive: boolean;
  setIsAlertActive: React.Dispatch<React.SetStateAction<boolean>>;
  contextAlertOptions: GlobalAlertOptions;
  setContextAlertOptions: React.Dispatch<React.SetStateAction<GlobalAlertOptions>>;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

function AlertProvider({ children }: { children: React.ReactNode }) {
  const [isAlertActive, setIsAlertActive] = useState(false);
  const [contextAlertOptions, setContextAlertOptions] = useState(defaultAlertOptions);

  return (
    <AlertContext.Provider
      value={{
        isAlertActive,
        setIsAlertActive,
        contextAlertOptions,
        setContextAlertOptions,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
}

function useAlertContext() {
  const context = useContext(AlertContext);

  if (context === undefined) {
    throw new Error('Incorrect use of Context');
  }

  return context;
}

export { AlertProvider, useAlertContext, AlertContext };
